import React from "react";
import { ButtonLayout, ButtonPrimary, ButtonSecondary, DataCard, Grid, skinVars, Text3 } from "@telefonica/mistica";
import { observer } from "mobx-react-lite";
import { DebitFGTSInstallments, SimulationValueCard } from "..";
import type { installments } from "../DebitFGTSInstallments";
import { strings } from "../../localization";

interface IProps {
	amountReceipt: number;
	extra?: React.ReactNode;
	collapsibleData?: installments[];
	collapsibleDataTAnalytic?(): void;
	onAnticipation(): void;
	onAlterValue(): void;
}

export const SimulationSummary: React.FC<IProps> = observer((props) => {
	const { amountReceipt, extra, collapsibleData, onAnticipation, onAlterValue, collapsibleDataTAnalytic } = props;
	const { title, primaryButton, secondaryButton } = strings.components.simulationSummary;

	return (
		<DataCard
			extra={
				<Grid gap={24}>
					<SimulationValueCard title={title} value={amountReceipt} />
					<ButtonLayout align="center">
						<ButtonPrimary onPress={onAnticipation} style={{ width: "100%" }}>
							<Text3 medium color={skinVars.colors.textButtonPrimary} textAlign="center">
								{primaryButton}
							</Text3>
						</ButtonPrimary>
						<ButtonSecondary onPress={onAlterValue} style={{ width: "100%" }}>
							<Text3 medium color={skinVars.colors.textButtonSecondary} textAlign="center">
								{secondaryButton}
							</Text3>
						</ButtonSecondary>
					</ButtonLayout>
					{extra}
					{collapsibleData && <DebitFGTSInstallments installments={collapsibleData} analytic={collapsibleDataTAnalytic}/>}
				</Grid>
			}
		/>
	);
});
